import { Action } from '@ngrx/store';

import { ForgotPasswordResponse } from 'modules/shared/models/auth.models';
import {
  LoginChallengeDispatchedAction, CompleteFirstLoginDispatchedAction, ConfirmNinetyDaysPasswordDispatchedAction,
  UpdateUserNameDispatchedAction, LogoutDispatchedAction, ForgotPasswordDispatchedAction, ChangePasswordDispatchedAction,
  ResetPasswordDispatchedAction, GetUserDispatchedAction, MfaConfirmDispatchedAction, MfaConfirmLoginDispatchedAction,
  GetUserRolesDispatchedAction
} from 'store/models/auth.models';
import { Role } from 'modules/shared/models/role.models';

export enum AuthActionTypes {
  // Login
  LOGIN = 'LOGIN',
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',
  LOGIN_FAILURE = 'LOGIN_FAILURE',
  CLEAR_LOGIN = 'CLEAR_LOGIN',

  // Get current user
  GET_USER = 'GET_USER',
  GET_USER_SUCCESS = 'GET_USER_SUCCESS',
  GET_USER_FAILURE = 'GET_USER_FAILURE',
  CLEAR_GET_USER = 'CLEAR_GET_USER',

  // Login Challenge required
  LOGIN_CHALLENGE_REQUIRED = 'LOGIN_CHALLENGE_REQUIRED',
  CLEAR_LOGIN_CHALLENGE_REQUIRED = 'CLEAR_LOGIN_CHALLENGE_REQUIRED',

  // Complete first login
  COMPLETE_FIRST_LOGIN = 'COMPLETE_FIRST_LOGIN',
  COMPLETE_FIRST_LOGIN_SUCCESS = 'COMPLETE_FIRST_LOGIN_SUCCESS',
  COMPLETE_FIRST_LOGIN_FAILURE = 'COMPLETE_FIRST_LOGIN_FAILURE',
  CLEAR_COMPLETE_FIRST_LOGIN = 'CLEAR_COMPLETE_FIRST_LOGIN',

  // Confirm ninety days password
  CONFIRM_NINETY_DAYS_PASSWORD = 'CONFIRM_NINETY_DAYS_PASSWORD',
  CONFIRM_NINETY_DAYS_PASSWORD_SUCCESS = 'CONFIRM_NINETY_DAYS_PASSWORD_SUCCESS',
  CONFIRM_NINETY_DAYS_PASSWORD_FAILURE = 'CONFIRM_NINETY_DAYS_PASSWORD_FAILURE',
  CLEAR_CONFIRM_NINETY_DAYS_PASSWORD = 'CLEAR_CONFIRM_NINETY_DAYS_PASSWORD',

  // Reset password
  RESET_PASSWORD = 'RESET_PASSWORD',
  RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE',
  CLEAR_RESET_PASSWORD = 'CLEAR_RESET_PASSWORD',

  // Update user name
  UPDATE_USER_NAME = 'UPDATE_USER_NAME',
  UPDATE_USER_NAME_SUCCESS = 'UPDATE_USER_NAME_SUCCESS',
  UPDATE_USER_NAME_FAILURE = 'UPDATE_USER_NAME_FAILURE',
  CLEAR_UPDATE_USER_NAME = 'CLEAR_UPDATE_USER_NAME',

  // Forgot password
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE',
  CLEAR_FORGOT_PASSWORD = 'CLEAR_FORGOT_PASSWORD',

  // Change password
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE',
  CLEAR_CHANGE_PASSWORD = 'CLEAR_CHANGE_PASSWORD',

  // MFA confirm
  MFA_CONFIRM = 'MFA_CONFIRM',
  MFA_CONFIRM_SUCCESS = 'MFA_CONFIRM_SUCCESS',
  MFA_CONFIRM_FAILURE = 'MFA_CONFIRM_FAILURE',
  CLEAR_MFA_CONFIRM = 'CLEAR_MFA_CONFIRM',

  // MFA confirm login
  MFA_CONFIRM_LOGIN = 'MFA_CONFIRM_LOGIN',
  MFA_CONFIRM_LOGIN_SUCCESS = 'MFA_CONFIRM_LOGIN_SUCCESS',
  MFA_CONFIRM_LOGIN_FAILURE = 'MFA_CONFIRM_LOGIN_FAILURE',
  CLEAR_MFA_CONFIRM_LOGIN = 'CLEAR_MFA_CONFIRM_LOGIN',

  // Enable MFA
  ENABLE_MFA = 'ENABLE_MFA',
  ENABLE_MFA_SUCCESS = 'ENABLE_MFA_SUCCESS',
  ENABLE_MFA_FAILURE = 'ENABLE_MFA_FAILURE',
  CLEAR_ENABLE_MFA = 'CLEAR_ENABLE_MFA',

  // Disable MFA
  DISABLE_MFA = 'DISABLE_MFA',
  DISABLE_MFA_SUCCESS = 'DISABLE_MFA_SUCCESS',
  DISABLE_MFA_FAILURE = 'DISABLE_MFA_FAILURE',
  CLEAR_DISABLE_MFA = 'CLEAR_DISABLE_MFA',

  // Logout
  LOGOUT = 'LOGOUT',

  // Get user roles
  GET_USER_ROLES = 'GET_USER_ROLES',
  GET_USER_ROLES_SUCCESS = 'GET_USER_ROLES_SUCCESS',
  GET_USER_ROLES_FAILURE = 'GET_USER_ROLES_FAILURE',
  CLEAR_GET_USER_ROLES = 'CLEAR_GET_USER_ROLES',

  // Login required
  LOGIN_REQUIRED = 'LOGIN_REQUIRED'
}

export type AuthActions = LogIn |
                          LogInSuccess |
                          LogInFailure |
                          ClearLogIn |
                          LoginChallengeRequired |
                          ClearLoginChallengeRequired |
                          CompleteFirstLogIn |
                          CompleteFirstLogInSuccess |
                          CompleteFirstLogInFailure |
                          ClearCompleteFirstLogIn |
                          UpdateUserName |
                          UpdateUserNameSuccess |
                          UpdateUserNameFailure |
                          ClearUpdateUserName |
                          ForgotPassword |
                          ForgotPasswordSuccess |
                          ForgotPasswordFailure |
                          ClearForgotPassword |
                          ChangePassword |
                          ChangePasswordSuccess |
                          ChangePasswordFailure |
                          ClearChangePassword |
                          MfaConfirm |
                          MfaConfirmSuccess |
                          MfaConfirmFailure |
                          ClearMfaConfirm |
                          MfaConfirmLogin |
                          MfaConfirmLoginSuccess |
                          MfaConfirmLoginFailure |
                          ClearMfaConfirmLogin |
                          LogInRequired |
                          GetUserRoles |
                          GetUserRolesSuccess |
                          GetUserRolesFailure |
                          ClearGetUserRoles |
                          LogOut;

// Start Login
export class LogIn implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.LOGIN;
  constructor(public payload: any = null) { }
}

export class LogInSuccess implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.LOGIN_SUCCESS;
  constructor(public payload: any = null) { }
}

export class LogInFailure implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.LOGIN_FAILURE;
  constructor(public payload: any = null) { }
}

export class ClearLogIn implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.CLEAR_LOGIN;
  constructor(public payload: any = null) { }
}
// End Login

// Start Get Current User
export class GetUser implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.GET_USER;
  constructor(public payload: GetUserDispatchedAction['payload']) { }
}

export class GetUserSuccess implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.GET_USER_SUCCESS;
  constructor(public payload: any) { }
}

export class GetUserFailure implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.GET_USER_FAILURE;
  constructor(public payload: any) { }
}

export class ClearGetUser implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.CLEAR_GET_USER;
  constructor(public payload: any = null) { }
}
// End Get Current User

// Start Login Challenge Required
export class LoginChallengeRequired implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.LOGIN_CHALLENGE_REQUIRED;
  constructor(public payload: LoginChallengeDispatchedAction['payload']) { }
}

export class ClearLoginChallengeRequired implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.CLEAR_LOGIN_CHALLENGE_REQUIRED;
  constructor(public payload: any = null) { }
}
// End Login Challenge Required

// Start Complete First Login
export class CompleteFirstLogIn implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.COMPLETE_FIRST_LOGIN;
  constructor(public payload: CompleteFirstLoginDispatchedAction['payload'] = null) { }
}

export class CompleteFirstLogInSuccess implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.COMPLETE_FIRST_LOGIN_SUCCESS;
  constructor(public payload: any) { }
}

export class CompleteFirstLogInFailure implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.COMPLETE_FIRST_LOGIN_FAILURE;
  constructor(public payload: any) { }
}

export class ClearCompleteFirstLogIn implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.CLEAR_COMPLETE_FIRST_LOGIN;
  constructor(public payload: any = null) { }
}
// End Complete First Login

// Start Confirm Ninety Days Password
export class ConfirmNinetyDaysPassword implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.CONFIRM_NINETY_DAYS_PASSWORD;
  constructor(public payload: ConfirmNinetyDaysPasswordDispatchedAction['payload'] = null) { }
}

export class ConfirmNinetyDaysPasswordSuccess implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.CONFIRM_NINETY_DAYS_PASSWORD_SUCCESS;
  constructor(public payload: any) { }
}

export class ConfirmNinetyDaysPasswordFailure implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.CONFIRM_NINETY_DAYS_PASSWORD_FAILURE;
  constructor(public payload: any) { }
}

export class ClearConfirmNinetyDaysPassword implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.CLEAR_CONFIRM_NINETY_DAYS_PASSWORD;
  constructor(public payload: any = null) { }
}
// End Confirm Ninety Days Password

// Start Reset Password
export class ResetPassword implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.RESET_PASSWORD;
  constructor(public payload: ResetPasswordDispatchedAction['payload'] = null) { }
}

export class ResetPasswordSuccess implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.RESET_PASSWORD_SUCCESS;
  constructor(public payload: boolean) { }
}

export class ResetPasswordFailure implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.RESET_PASSWORD_FAILURE;
  constructor(public payload: any) { }
}

export class ClearResetPassword implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.CLEAR_RESET_PASSWORD;
  constructor(public payload: any = null) { }
}
// End Reset Password

// Start Update User Name
export class UpdateUserName implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.UPDATE_USER_NAME;
  constructor(public payload: UpdateUserNameDispatchedAction['payload'] = null) { }
}

export class UpdateUserNameSuccess implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.UPDATE_USER_NAME_SUCCESS;
  constructor(public payload: boolean) { }
}

export class UpdateUserNameFailure implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.UPDATE_USER_NAME_FAILURE;
  constructor(public payload: any) { }
}

export class ClearUpdateUserName implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.CLEAR_UPDATE_USER_NAME;
  constructor(public payload: any = null) { }
}
// End Update User Name

// Start Forgot Password
export class ForgotPassword implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.FORGOT_PASSWORD;
  constructor(public payload: ForgotPasswordDispatchedAction['payload'] = null) { }
}

export class ForgotPasswordSuccess implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.FORGOT_PASSWORD_SUCCESS;
  constructor(public payload: ForgotPasswordResponse) { }
}

export class ForgotPasswordFailure implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.FORGOT_PASSWORD_FAILURE;
  constructor(public payload: any) { }
}

export class ClearForgotPassword implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.CLEAR_FORGOT_PASSWORD;
  constructor(public payload: any = null) { }
}
// End Forgot Password

// Start Change Password
export class ChangePassword implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.CHANGE_PASSWORD;
  constructor(public payload: ChangePasswordDispatchedAction['payload'] = null) { }
}

export class ChangePasswordSuccess implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.CHANGE_PASSWORD_SUCCESS;
  constructor(public payload: boolean) { }
}

export class ChangePasswordFailure implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.CHANGE_PASSWORD_FAILURE;
  constructor(public payload: any) { }
}

export class ClearChangePassword implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.CLEAR_CHANGE_PASSWORD;
  constructor(public payload: any = null) { }
}
// End Change Password

// Start MFA confirm
export class MfaConfirm implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.MFA_CONFIRM;
  constructor(public payload: MfaConfirmDispatchedAction['payload']) { }
}

export class MfaConfirmSuccess implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.MFA_CONFIRM_SUCCESS;
  constructor(public payload: boolean) { }
}

export class MfaConfirmFailure implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.MFA_CONFIRM_FAILURE;
  constructor(public payload: any) { }
}

export class ClearMfaConfirm implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.CLEAR_MFA_CONFIRM;
  constructor(public payload: any = null) { }
}
// End MFA confirm

// Start MFA confirm login
export class MfaConfirmLogin implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.MFA_CONFIRM_LOGIN;
  constructor(public payload: MfaConfirmLoginDispatchedAction['payload']) { }
}

export class MfaConfirmLoginSuccess implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.MFA_CONFIRM_LOGIN_SUCCESS;
  constructor(public payload: any) { }
}

export class MfaConfirmLoginFailure implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.MFA_CONFIRM_LOGIN_FAILURE;
  constructor(public payload: any) { }
}

export class ClearMfaConfirmLogin implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.CLEAR_MFA_CONFIRM_LOGIN;
  constructor(public payload: any = null) { }
}
// End MFA confirm login

// Start enable MFA
export class EnableMfa implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.ENABLE_MFA;
  constructor(public payload: any = null) { }
}

export class EnableMfaSuccess implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.ENABLE_MFA_SUCCESS;
  constructor(public payload: string) { }
}

export class EnableMfaFailure implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.ENABLE_MFA_FAILURE;
  constructor(public payload: any) { }
}

export class ClearEnableMfa implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.CLEAR_ENABLE_MFA;
  constructor(public payload: any = null) { }
}
// End enable MFA

// Start disable MFA
export class DisableMfa implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.DISABLE_MFA;
  constructor(public payload: any = null) { }
}

export class DisableMfaSuccess implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.DISABLE_MFA_SUCCESS;
  constructor(public payload: boolean) { }
}

export class DisableMfaFailure implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.DISABLE_MFA_FAILURE;
  constructor(public payload: any) { }
}

export class ClearDisableMfa implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.CLEAR_DISABLE_MFA;
  constructor(public payload: any = null) { }
}
// End disable MFA

// Logout
export class LogOut implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.LOGOUT;
  constructor(public payload: LogoutDispatchedAction['payload']) { }
}

// Start get user roles
export class GetUserRoles implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.GET_USER_ROLES;
  constructor(public payload: GetUserRolesDispatchedAction['payload']) { }
}

export class GetUserRolesSuccess implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.GET_USER_ROLES_SUCCESS;
  constructor(public payload: Array<Role>) { }
}

export class GetUserRolesFailure implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.GET_USER_ROLES_FAILURE;
  constructor(public payload: any) { }
}

export class ClearGetUserRoles implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.CLEAR_GET_USER_ROLES;
  constructor(public payload: any = null) { }
}
// End get user roles

// Login required
export class LogInRequired implements Action {
  readonly type: AuthActionTypes = AuthActionTypes.LOGIN_REQUIRED;
  constructor(public payload: any = null) { }
}
